import { createContext } from 'react'
const PosTaskEffectivityContext = createContext('Default Value')
export default PosTaskEffectivityContext